import { get } from 'lodash'

const initialValuesParental = data => ({
  title: get(data, 'title'),
  firstName: get(data, 'parentFirstName'),
  lastName: get(data, 'parentLastName'),
  email: get(data, 'parentEmail'),
  phoneNumber: get(data, 'parentPhone'),
  relationship: get(data, 'parentRelationship'),
  addressLine1: get(data, 'line1'),
  addressLine2: get(data, 'line2'),
  addressCity: get(data, 'city'),
  addressStateOrProvince: get(data, 'stateOrProvinceOrRegion'),
  addressZipCode: get(data, 'zipCode')
})

export default initialValuesParental
